<template>
  <div>
    <title>分销回收</title>
    <article class="cardArticle">
      <section class="cardCon">
        <header class="tabHeader">
          <p>
            <router-link :to="{path:'/CardsOut'}" v-if="openStoreDefinition==1">券卡定义激活</router-link>
            <router-link :to="{path:'/CardsActivation'}">券卡激活</router-link>
            <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
            <router-link :to="{path:'/CardsReuse'}">券卡恢复</router-link>
            <router-link class="isActive" :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
            <router-link  :to="{path:'/CardMdShop'}" v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
          </p>
        </header>
        <main class="cardMain">
          <!-- S 券卡验证表单 -->
          <CodeCheck v-if="update" @verifytype="verifyType" :operType="15" :codeType="codeType"></CodeCheck>
          <!-- E 券卡验证表单 -->
          <section>
            <el-form :model="basicForm" v-model="labelPosition" label-width="100px">
              <!-- S 基础设置 -->
              <p class="commonTit"><b>基础设置</b></p>
              <section class="basicSet">
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="basicForm.memo" maxlength="100"></el-input>
                </el-form-item>
              </section>
            </el-form>
          </section>
        </main>
        <div class="bottomBtn">
          <el-button type="primary" @click="suBmission" :loading="loadingshow">提交</el-button>
          <el-button @click="reload">重置</el-button>
        </div>
      </section>
    </article>
    <el-dialog title="提示" :visible.sync="cancelTip" class="tipBox" append-to-body :close-on-click-modal="false">
      <span class="mainBooks">
        <img src="https://presale.jhtsoft.com/picms/4ea895bf237c.png" alt="">
        <small> <i>分销回收</i>操作将<b>清空</b>券卡的商品绑定、有效期、券卡销售情况等
          <b>一切相关券卡属性</b>，<br>
          分销回收操作<b>不能撤回</b>，请谨慎操作！<b>回收后的券卡将恢复成一张白卡，</b> 可以重新出库使用！
        </small>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelTip = false">我已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import Api from "@/apis/api.js";
  import { Message, MessageBox } from "element-ui";
  import { mapState, mapActions } from "vuex";
  export default {
    name: 'CardsRecover',
    components: {
      CodeCheck: resolve =>
        require(["@/components/CardsFolder/CodeCheck.vue"], resolve), //验证全码
    },
    data() {
      return {
        openStoreDefinition:0,
        cancelTip: false,
        loadingshow: false,
        update: true,
        codeType: '0',//券卡类型-礼品券卡
        labelPosition: "right", //labe文字右对齐,
        // 基础设置表单
        verifytype: 0,
        basicForm: {
          memo: '',//备注
        },
      }
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ============================================== 方法 ==============================================
    methods: {
      // 验证类型
      verifyType(type) {
        this.verifytype = type
      },
      // 提交
      suBmission() {
        MessageBox.confirm('回收后券卡将被恢复为总部定义的状态，请谨慎操作！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.submission()
        }).catch(() => {

        });
      },
      submission() {
        this.loadingshow = true;
        let param = {
          verifytype: this.verifytype,
          memo: this.basicForm.memo
        }
        Api.MDHUISHOUOPER(param).then(res => {
          if (res.data.status == "200") {
            this.reload();
            this.loadingshow = false;
            MessageBox.confirm(res.data.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'success'
            }).then(() => { }).catch(() => { });
          } else {
            if (res.data.status == "201") {
              this.reload();
            }
            this.loadingshow = false;
            MessageBox.confirm(res.data.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(() => { }).catch(() => { });
          }
        })
      },
      reload() {
        this.basicForm = {
          memo: "", //备注
        }
        // 移除组件
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true
        })
      }
    },
    mounted() {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition');
    }
  }
</script>
<style scoped>
  .cardMain>>>.el-input__inner {
    color: #666;
  }

  .cardCon {
    position: relative;
    padding: 84px 20px 85px 0;
    height: calc(100% - 169px);
  }

  @media (max-width: 1310px) {
    .cardCon header a {
      padding: 0 16px;
    }
  }

  .basicSet {
    padding: 20px;
  }

  .basicSet .el-input,
  .basicSet .el-textarea {
    width: 300px;
  }

  /* 券卡作废弹框提示 */
  .tipBox>>>.el-dialog {
    width: 850px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin: 0 auto !important;
  }

  .tipBox>>>.el-dialog__header {
    height: 45px;
    background-color: #F5F7FA;
    padding: 0 20px;
    line-height: 45px;
    font-size: 18px;
  }

  .tipBox>>>.el-dialog__headerbtn {
    top: 10.5px;
    width: 20px;
    height: 24px;
  }

  .tipBox>>>.el-dialog__headerbtn .el-dialog__close {
    color: #C0C4CC;
    display: block;
    font-size: 24px !important;
  }

  .tipBox>>>.el-dialog__body {
    padding: 50px 20px;
  }

  .tipBox>>>.el-dialog__footer {
    text-align: center;
  }

  .mainBooks {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .mainBooks>img {
    width: 60px;
    margin-right: 15px;
    margin-bottom: -5px;
  }

  .mainBooks>small {
    line-height: 1.5;
    letter-spacing: 1.5px;
  }

  .mainBooks>small>i {
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }

  .mainBooks>small>b {
    font-size: 18px;
    color: red;
  }
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsRecover.vue